import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router';
import { statusColours } from '../../constants/ColourConstants';

import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';

import LinearProgress from 'material-ui/LinearProgress';

import { ListItem } from 'material-ui/List';

import InfoIcon from 'material-ui/svg-icons/action/info';
import LaunchIcon from 'material-ui/svg-icons/action/launch';

import SettingsIcon from 'material-ui/svg-icons/action/settings';
import SubjectIcon from 'material-ui/svg-icons/action/subject';
import LibraryIcon from 'material-ui/svg-icons/av/library-books';
import VideoIcon from 'material-ui/svg-icons/av/video-library';
import AudioIcon from 'material-ui/svg-icons/av/library-music';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import SchoolIcon from 'material-ui/svg-icons/social/school';
import PrivateIcon from 'material-ui/svg-icons/action/lock';
import SkillIcon from 'material-ui/svg-icons/social/public';
import CPDIcon from 'material-ui/svg-icons/toggle/star';
import EnrolmentIcon from 'material-ui/svg-icons/action/check-circle';


import ROLES from '../../constants/Roles';
import buildContextMenu from '../Common/BuildContextMenu';

const style = {
    menu: {
        marginRight: 0,
        marginBottom: 0,
        float: 'left',
        position: 'relative',
        zIndex: 0,
    },
    iconButton: {
        marginRight: 0,
    },
    listItem: {
        padding: '2px',
    },
    icon: {
        height: '32px',
        width: '32px',
    }
};





const ModuleListItem = React.createClass({

    getActions: function(row) {

        const infoLink     = '/dashboard/module/' + row.id;

        return [
            {
                link: infoLink,
                label: 'Preview',
                icon: <InfoIcon />
            },
            {
                type:'divider'
            },
            {
                link: `/dashboard/module/${row.id}/enrolments`,
                label: 'Enrolments',
                icon: <EnrolmentIcon />,
                condition: {
                    show: this.context.auth.canEdit(row.access),
                    roles: [ROLES.MANAGER]
                }
            },
            {
                type:'divider'
            },
            {
                link: `/dashboard/module/${row.id}/settings`,
                label: 'Settings',
                icon: <SettingsIcon />,
                condition: {
                    show: this.context.auth.canEdit(row.access),
                    roles: [ROLES.ADMIN]
                }
            },
        ];
    },
    
    render: function() {

        const row = this.props.data;
        const infoLink = this.props.link || `/dashboard/module/${row.id}`;
        const actions = (this.props.actions || this.getActions(row));
        const menuItems = buildContextMenu(actions, this.context.auth);

        let displayDuration = '';
        const duration =  parseInt(row.duration);
        if (duration > 0) {
            let hours = Math.floor( duration / 60);
            let minutes = duration % 60;

            if (hours > 0) {
                displayDuration = hours + 'h';
                if (minutes > 0) {
                    displayDuration += ' ' + minutes + 'm';
                }
            } else if (minutes > 0) {
                displayDuration = minutes + 'm';
            }
            displayDuration = ' - ' + displayDuration;
        }

        const summary = row.name;
        let description = row.type + displayDuration;
        let statusLine  = '';

        let listItemProps = {
            key: row.id,
            style: style.listItem,
        };

        let iconGroup = [];
        if (row.visibility === 'private') {
            iconGroup.push(<PrivateIcon className="icon-small" key="visibility" />);
        }

        if (row.skillId) {
            iconGroup.push(<SkillIcon className="icon-small" key="skill" />);
        }

        if (Number(row.cpdCredits)) {
            iconGroup.push(<CPDIcon className="icon-small" key="cpd" />);
        }
        
        switch(row.enrolmentStatus) {

            case 'waiting':
                statusLine  = row.enrolmentStatus;
                break;

            case 'enrolled':
                if (row.enrolmentProgress > 0 ) {
                    if (!!row.requirement && !!row.enrolmentScore && row.requirement <= row.enrolmentScore) {
                        statusLine = 'passed - score: ' + row.enrolmentScore  ;
                    } else {
                        statusLine  = 'in progress';
                        if (row.enrolmentProgress > 1 ) {
                            statusLine  += ' - ' + row.enrolmentProgress + '%';
                        }
                    }
                } else {
                    let dateEnrolled = (row.dateAdded) ? ' on ' + new Date(row.dateAdded).toDateString() : null;
                    statusLine  = 'Enrolled ' + dateEnrolled;
                }

                break;

            case 'completed':
                statusLine = 'Completed';
                if (!!row.completedDate) {
                    const completedDate = new Date(row.completedDate);
                    if (!!completedDate && !isNaN(completedDate.valueOf())) {
                        statusLine += ` - ${completedDate.toDateString()}`;
                    }
                }
                if (!!row.enrolmentScore) {
                    statusLine += ` - score:${row.enrolmentScore}`;
                }
                break;

            case 'cancelled':
                statusLine = 'Cancelled';
                break;

            default:
                break;
        }

        listItemProps.primaryText = (
            <Link to={infoLink} className="primaryText">
                {summary}
            </Link>
        );

        if (row.loading) {
            listItemProps.secondaryText = <div><LinearProgress mode="indeterminate"/></div>;
        } else {
            listItemProps.secondaryText = <Link to={infoLink} className="secondaryText">
                <em>{description}{statusLine}</em>
                <br />
                {iconGroup}
            </Link>;
            listItemProps.secondaryTextLines = 2;

        }

        if (menuItems.length > 0) {
            const topRight = {horizontal: 'right', vertical: 'top'};
            const iconMenuProps = {
                menuStyle: style.menu,
                anchorOrigin: topRight,
                targetOrigin: topRight,
            };

            listItemProps.rightIcon =
            <IconMenu {...iconMenuProps}
                iconButtonElement={
                    <IconButton touch={true} >
                        <MoreVertIcon color={statusColours.light} style={style.iconButton} />
                    </IconButton>
                }
            >
                {menuItems}
            </IconMenu>

        }

        let avatarIcon = (<SubjectIcon color={statusColours.primary} />);

        switch(row.type) {

            case 'classroom':
                avatarIcon = (<SchoolIcon style={style.icon} color={statusColours.primary} />);
                break;

            case 'e-learning':
                avatarIcon = (<LaunchIcon style={style.icon} color={statusColours.primary} />);
                break;

            case 'video':
                avatarIcon = (<VideoIcon style={style.icon} color={statusColours.primary} />);
                break;

            case 'audio':
                avatarIcon = (<AudioIcon style={style.icon} color={statusColours.primary} />);
                break;

            case 'resource':
                avatarIcon = (<LibraryIcon style={style.icon} color={statusColours.primary} />);
                break;

            default:
                break;
        }

        return (
                <ListItem {...listItemProps}
                    leftAvatar={
                        <Link to={infoLink}>
                            {avatarIcon}
                        </Link>
                    }
                />
        )
    }
});

ModuleListItem.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default ModuleListItem;
